<template>
    <div id="ambis-meter">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Ambis Meter', to: { path: '/ambis-meter' } },
                { text: 'Quotes' },
            ]"
            divider=">"
        ></v-breadcrumbs>
        <h3 class="header-text font-weight-bold">List Quote Ambis Meter</h3>

        <v-card>
            <v-card-title>
                Quotes Ambis Meter
                <v-spacer></v-spacer>
                <v-btn
                    class="align-center text-body-2 blew white--text"
                    @click="createQuote()"
                >
                    <v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Quote
                </v-btn>
            </v-card-title>
            <v-divider />

            <app-datatable
                :items="quotes"
                :headers="headers"
                :key="tableKey"
                :custom-pagination-total-items="quotes.length"
                :custom-pagination-per-page="10"
                :custom-pagination-current-page="1"
                :custom-pagination-sort-mode="pagination.sortMode"
                :customWidth="true"
                v-on:selected="selectedRow = $event"
                v-on:dblClicked="editQuote()"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import _ from "lodash";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import AmbisMeterService from "@/modules/ambis_meter/services/ambis_meter.js";

export default {
    name: "quote",

    components: {
        "app-datatable": DataTable,
        "app-spinner": AppSpinner,
    },

    data: function () {
        return {
            isLoading: false,
            selectedRow: null,
            search: null,
            tableKey: 0,
            total_data: 0,
            pagination: {
                perPage: 1000,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
            },
            quotes: [],
            headers: [
                { text: "Quote", value: "quote", max_width: "5px" },
                { text: "Level", value: "level_name" },
            ],
            headersKey: ["quote", "level_name"],
        };
    },

    mounted: function () {
        this.fetchData();
    },

    methods: {
        fetchData: function () {
            var pagination = {
                size: this.pagination.perPage,
                page: this.pagination.currentPage,
            };

            var context = this;
            this.quotes = [];

            AmbisMeterService.getListQuote(pagination, (result) => {
                if (result.success) {
                    result.data.quotes.forEach(function (response, index) {
                        context.total_data = result.data.total_data;
                        var row = {
                            no: index,
                            id: response.id,
                            quote: response.quote,
                            level_id: response.level_id.id,
                            level_name: response.level_id.name,
                        };

                        context.quotes.push(row);
                        context.quotes = _.orderBy(
                            context.quotes,
                            "id",
                            "desc",
                        );
                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        createQuote: function () {
            this.$router.push({ path: "/quote-form" });
        },

        editQuote: function () {
            var context = this;
            context.isLoading = true;
            var quoteId = this.selectedRow.id;
            context.$store.commit("quote_init", this.selectedRow);
            context.$router.push({
                path: "/quote-form",
                query: { id: quoteId },
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// Quote.vue?40654762